import { CommonModule as AngularCommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '../common/common.module';
import { AuthModule } from '../auth/auth.module';
import { LoginComponent } from './login.component';
import { LoginSuccessComponent } from '../loginSuccess/loginSuccess.component';

@NgModule({
    declarations: [
        LoginComponent,
        LoginSuccessComponent
    ],
    exports: [
        LoginComponent,
        LoginSuccessComponent
    ],
    imports: [
        AngularCommonModule,
        NgbModule,
        AuthModule,        
        CommonModule
    ]
})
export class LoginModule {

}
